<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Skins
        <small>Skin list</small>
      </h1>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <form class="col-sm-6">

          <div class="form-group">
            <input type="text" class="form-control" placeholder="Search..." @keyup="skinSearchDB();" v-model="skinSearch">
          </div>
        </form>
        <div class="col-sm-offset-1 col-sm-3">

          <a class="rename-skins btn btn-danger" @click="rename=!rename"><i  class="edit icon"></i>Change skins name</a>
        </div>
      </div>


      <div class="row">
        <div class="ui six stackable cards" id="skins-cards"  v-if="skins.images.length">
          <div :class="'col-sm-6 col-md-4 card col-lg-' + bigScreenSkins" :data-skin-id="item.id" v-for="item in skins.visible_images">
              <img class="card-img-top" :src="baseUrl2 + '/public/images/skins/'+item.skin_name+'.png'">
              <div class="card-block">

                <div class="card-text">
                  <span v-if="role >= 33">{{ item.ip }}</span> <span class="pull-right" v-if="role >= 33">{{ item.approved_by}}</span>
                </div>
              </div>
              <div class="card-footer">
                <h4 class="text-center card-title mt-3"  v-if="!rename">{{ item.skin_name }}</h4>

                <div class="ui bottom attached button chose-skin edit-name" v-else>
                  <div class="input-group">
                    <input type="text" class="form-control" :value="item.skin_name">
                    <span class="input-group-addon" @click="renameSkinDB(item.skin_name, $event.target)">
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    </span>
                  </div>

                </div>
                <button @click="removeSkinDB(item.id, item.skin_name)" class="btn btn-danger btn-sm">Delete</button>
                <button v-if="Number(item.safe)" @click="safeSkin(item.id, item.skin_name, 0)" class="btn btn-success pull-right btn-sm">Siguran skin</button>
                <button v-if="!Number(item.safe)" @click="safeSkin(item.id, item.skin_name, 1)" class="btn btn-warning pull-right btn-sm">Nije siguran</button>
              </div>
          </div>
        </div>



      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'Skins',

    data: function () {
      return {
        baseUrl2: 'https://agar.rs',
        loading: true,
        rename: false,
        skins: new Form({
          images: [],
          visible_images: [],
          skin_name: ''
        }),
        skinSearch: '',
        isActiveSearch: false,
        scrollCalled: 0,
        isLoadingNew: false,
        role: 1,
        bigScreenSkins: 3

      }
    },
    methods: {
      getSkinsDB: function () {
        var self = this
        this.skins.post(baseUrl + 'Skins/getSkinList/1').then(function (result) {
          self.skins.images = result.list
          self.skins.visible_images = result.list
          self.loading = false
        }, function (reason) {
          // rejection
        })
      },
      getSkinsDBNext: function () {
        var self = this

        this.isLoadingNew = true
        var data = {}
        data['position'] = $('.card').last().attr('data-skin-id')

        this.skins.post(baseUrl + 'Skins/getSkinListNext/1', data).then(function (result) {
          self.skins.visible_images = self.skins.visible_images.concat(result.list)
          self.scrollCalled = 0
          self.isLoadingNew = false
        }, function (reason) {
          // rejection
        })
      },
      skinSearchDB: function () {
        var self = this
        if (this.skinSearch.length === 0) {
          this.skins.visible_images = this.skins.images.slice()
        }
        if (this.skinSearch.length > 2) {
          this.isActiveSearch = true
          var data = {}
          data['term'] = this.skinSearch
          this.skins.visible_images = []
          this.skins.post(baseUrl + 'Skins/searchSkin/1', data).then(function (result) {
            if (result.status === 1) {
              self.skins.visible_images = result.list.slice()
              self.isActiveSearch = false
            }
          }, function (reason) {
            // rejection
          })
        }
      },
      // Admin functions
      renameSkinDB: function (oldname, meta) {
        var name = $(meta).prev('input').val()
        var data = {
          'user_id': localStorage.user_id,
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log,
          'name': name,
          'oldname': oldname
        }

        this.skins.post(baseUrl + 'Skins/renameSkin', data).then(function (result) {
          if (result.status === 1) {
          }
          // error
          if (result.status !== 1) {
            alert('Greska. Ime verovatno postoji. Probaj drugo ime')
          }
        }, function (reason) {
        })
      },
      safeSkin: function (id, name, safe) {
        var self = this
        var data = {
          'user_id': localStorage.user_id,
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log,
          'name': name,
          'id': id,
          'safe': safe
        }
        this.skins.post(baseUrl + 'Skins/toSafeSkins', data).then(function (result) {
          if (result.status === 1) {
            self.skins.visible_images.find((o, i) => {
              if (o.skin_name === data.name) {
                if (i >= 0) {
                  o.safe = data.safe
                  return 0
                }
              }
            })
          }
        }, function (reason) {
          // rejection
        })
      },
      removeSkinDB: function (id, name) {
        var self = this
        var data = {
          'user_id': localStorage.user_id,
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log,
          'name': name,
          'id': id
        }
        this.skins.post(baseUrl + 'Skins/removeSkin', data).then(function (result) {
          if (result.status === 1) {
            self.skins.visible_images.find((o, i) => {
              if (o.skin_name === name) {
                if (i >= 0) {
                  self.skins.visible_images.splice(i, 1)
                  return 0
                }
              }
            })
          }
          if (result.status === 2) {
            // not allowed to change
            // set user role?
            localStorage.setItem('role', result.role)
          }
          // error
          if (result.status !== 1) {
            alert('Greska. Skin je vec obrisan')
          }
        }, function (reason) {
          // rejection
        })
      }
    },
    updated () {
      var self = this
      // Load new images on scroll
      $(window).scroll(function (event) {
        if (self.scrollCalled === 0) {
          if ($(this).scrollTop() + $(this).innerHeight() >= $('body')[0].scrollHeight) {
            if (self.skinSearch.length < 3) {
              self.scrollCalled = 1
              self.getSkinsDBNext()
            }
          }
        }
      })
    },
    created: function () {
      if (screen.width > 1500) {
        this.bigScreenSkins = 2
      }
      this.getSkinsDB()
      this.role = this.$store.state.role
    }
  }
</script>

<style>

  .card {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
  }

  .card-body {
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
  }

  .card-title {
    margin-bottom: 0.75rem;
  }

  .card-subtitle {
    margin-top: -0.375rem;
    margin-bottom: 0;
  }

  .card-text:last-child {
    margin-bottom: 0;
  }

  .card-link:hover {
    text-decoration: none;
  }

  .card-link + .card-link {
    margin-left: 1.25rem;
  }

  .card > .list-group:first-child .list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .card > .list-group:last-child .list-group-item:last-child {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  }

  .card-header:first-child {
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
  }

  .card-footer {
    padding: 0.75rem 1.25rem;
    background-color: rgba(0, 0, 0, 0.03);
    border-top: 1px solid rgba(0, 0, 0, 0.125);
  }

  .card-footer:last-child {
    border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
  }

  .card-header-tabs {
    margin-right: -0.625rem;
    margin-bottom: -0.75rem;
    margin-left: -0.625rem;
    border-bottom: 0;
  }

  .card-header-pills {
    margin-right: -0.625rem;
    margin-left: -0.625rem;
  }

  .card-img-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 1.25rem;
  }

  .card-img {
    width: 100%;
    border-radius: calc(0.25rem - 1px);
  }

  .card-img-top {
    width: 100%;
    border-top-left-radius: calc(0.25rem - 1px);
    border-top-right-radius: calc(0.25rem - 1px);
  }

  .card-img-bottom {
    width: 100%;
    border-bottom-right-radius: calc(0.25rem - 1px);
    border-bottom-left-radius: calc(0.25rem - 1px);
  }

  @media (min-width: 576px) {
    .card-deck {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-flow: row wrap;
      flex-flow: row wrap;
      margin-right: -15px;
      margin-left: -15px;
    }
    .card-deck .card {
      display: -ms-flexbox;
      display: flex;
      -ms-flex: 1 0 0%;
      flex: 1 0 0%;
      -ms-flex-direction: column;
      flex-direction: column;
      margin-right: 15px;
      margin-left: 15px;
    }
  }

  @media (min-width: 576px) {
    .card-group {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-flow: row wrap;
      flex-flow: row wrap;
    }
    .card-group .card {
      -ms-flex: 1 0 0%;
      flex: 1 0 0%;
    }
    .card-group .card + .card {
      margin-left: 0;
      border-left: 0;
    }
    .card-group .card:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .card-group .card:first-child .card-img-top {
      border-top-right-radius: 0;
    }
    .card-group .card:first-child .card-img-bottom {
      border-bottom-right-radius: 0;
    }
    .card-group .card:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    .card-group .card:last-child .card-img-top {
      border-top-left-radius: 0;
    }
    .card-group .card:last-child .card-img-bottom {
      border-bottom-left-radius: 0;
    }
    .card-group .card:not(:first-child):not(:last-child) {
      border-radius: 0;
    }
    .card-group .card:not(:first-child):not(:last-child) .card-img-top,
    .card-group .card:not(:first-child):not(:last-child) .card-img-bottom {
      border-radius: 0;
    }
  }

  .card-columns .card {
    margin-bottom: 0.75rem;
  }

  @media (min-width: 576px) {
    .card-columns {
      -webkit-column-count: 3;
      column-count: 3;
      -webkit-column-gap: 1.25rem;
      column-gap: 1.25rem;
    }
    .card-columns .card {
      display: inline-block;
      width: 100%;
    }
  }

  .rename-skins {
    color: #fff;
    text-transform: uppercase;
    cursor: pointer;
  }
  .rename-skins:hover {
    color: #fff;
    text-decoration: underline;
  }
  .input-group-addon {
    cursor: pointer;
  }
  @media (min-width: 992px) {
  .card-text {
    min-height: 30px;
  }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?95420d3c